export default __webpack_public_path__ + "static/media/sajek.3b733868.jpg";